import React from "react";
import { OrganizationSectionCard } from "./components/organization-section-card.component";
import {
	UserX,
	FileStack,
	ClipboardList,
	Package,
	Tags,
	FileEdit,
	Users,
	Database,
	Coins,
	Shield,
	FolderTree,
	Settings,
	Printer,
} from "lucide-react";

interface Card {
	title: string;
	description: string;
	icon: React.ReactNode;
	path: string;
	category: string;
}

const laborverwaltung: Card[] = [
	{
		title: "Firmenangaben",
		description:
			"Die Stammdaten zu Ihrem Labor wie Firmenname, Adresse, GLN, etc.",
		icon: <Settings className="w-5 h-5 text-blue-500" />,
		path: "/organisation/administration/firmenangaben",
		category: "Laborverwaltung",
	},
	{
		title: "Rechnungswesen",
		description:
			"Ihre Standardwerte für das Rechnungswesen Ihres Labors. Standard-Abrechnungssystem, Standard-Preislisten, Standard-Konto, etc.",
		icon: <Settings className="w-5 h-5 text-blue-500" />,
		path: "/organisation/administration/rechnungswesen",
		category: "Laborverwaltung",
	},
	{
		title: "Konten",
		description:
			"Hier können Sie Bankkonten anlegen und verwalten, für die Rechnungen erstellt werden können.",
		icon: <Settings className="w-5 h-5 text-blue-500" />,
		path: "/organisation/administration/konten",
		category: "Laborverwaltung",
	},
	{
		title: "Mahnungen",
		description:
			"Hier finden Sie alle Einstellungen für das Mahnwesen Ihres Labors.",
		icon: <Settings className="w-5 h-5 text-blue-500" />,
		path: "/organisation/administration/mahnungswesen",
		category: "Laborverwaltung",
	},
	{
		title: "Regionen",
		description:
			"Falls Ihr Labor in mehreren Regionen tätig ist, können Sie diese hier aktivieren und Grundeinstellungen pro Region vornehmen.",
		icon: <Settings className="w-5 h-5 text-blue-500" />,
		path: "/organisation/administration/regionen",
		category: "Laborverwaltung",
	},
	{
		title: "Garanten",
		description: "Hier können Sie Garanten anlegen und verwalten.",
		icon: <Shield className="w-5 h-5 text-blue-500" />,
		path: "/organisation/administration/garanten",
		category: "Laborverwaltung",
	},
	{
		title: "Benutzerverwaltung",
		description:
			"Hier können Sie für Ihre Mitarbeiter Benutzeraccounts anlegen, verwalten und verschiedene Zugriffsrechte geben.",
		icon: <Users className="w-5 h-5 text-blue-500" />,
		path: "/organisation/administration/benutzerverwaltung",
		category: "Laborverwaltung",
	},
	{
		title: "Konfigurationseinstellungen",
		description:
			"Hier können Sie spezielle Konfigurationen für Ihr Labor anpassen.",
		icon: <Settings className="w-5 h-5 text-blue-500" />,
		path: "/organisation/administration/konfigurationseinstellungen",
		category: "Laborverwaltung",
	},
	{
		title: "Abonnement",
		description: "Hier können Sie das Abonnement Ihres Labors verwalten.",
		icon: <Package className="w-5 h-5 text-blue-500" />,
		path: "/organisation/administration/abonnement",
		category: "Laborverwaltung",
	},
	{
		title: "Datenbank Sicherung",
		description:
			"Exportiere Lieferscheine und Rechnungen als CSV-Datei für einen gewählten Zeitraum.",
		icon: <Database className="w-5 h-5 text-blue-500" />,
		path: "/organisation/administration/datenbank-sicherung",
		category: "Laborverwaltung",
	},
	{
		title: "Dental Lab XP Import",
		description:
			"Importiere Lieferscheine, Kunden und weitere Stammdaten aus Dental Lab XP.",
		icon: <Database className="w-5 h-5 text-blue-500" />,
		path: "/organisation/migration",
		category: "Laborverwaltung",
	},
	{
		title: "Druckereinstellungen",
		description: "Verwalten Sie die Druckereinstellungen für Ihr Labor.",
		icon: <Printer className="w-5 h-5 text-blue-500" />,
		path: "/organisation/administration/drucker",
		category: "Laborverwaltung",
	},
	{
		title: "Druckeraufträge",
		description: "Übersicht über alle Druckaufträge Ihres Labors.",
		icon: <ClipboardList className="w-5 h-5 text-blue-500" />,
		path: "/organisation/administration/druckerauftraege",
		category: "Laborverwaltung",
	},
];

const schnelleProzesse: Card[] = [
	{
		title: "Leistungskatalog",
		description:
			"Erstellen Sie einen eigenen Leistungskatalog mit Ordnern für schnelles Hinzufügen von Positionen.",
		icon: <FolderTree className="w-5 h-5 text-blue-500" />,
		path: "/organisation/leistungskatalog",
		category: "Schnelle Prozesse",
	},
	{
		title: "Vorlagen/Jumbos",
		description:
			"Jumbos sind Gruppen von Positionen für schnelles Erstellen von Kostenvoranschlägen und Lieferscheinen.",
		icon: <FileStack className="w-5 h-5 text-blue-500" />,
		path: "/organisation/vorlagen-jumbos",
		category: "Schnelle Prozesse",
	},
	{
		title: "Auftragsansichten",
		description:
			"Auftragsansichten erlauben Ihnen, frei zu konfigurieren, welche Informationen Sie bei einem Auftrag hinterlegen möchten und wie diese visualisiert werden sollen.",
		icon: <ClipboardList className="w-5 h-5 text-blue-500" />,
		path: "/organisation/auftragsansichten",
		category: "Schnelle Prozesse",
	},
];

const stammdaten: Card[] = [
	{
		title: "Tarifkataloge",
		description:
			"Verwalten Sie Ihre Leistungen pro Abrechnungssystem. Erstellen Sie eigene Kataloge, Kategorien, Leistungen und Preislisten.",
		icon: <Tags className="w-5 h-5 text-blue-500" />,
		path: "/organisation/leistungen",
		category: "Stammdaten",
	},
	{
		title: "Artikel",
		description:
			"Hier können Sie Artikel (wie z.B. Materialien) anlegen und verwalten.",
		icon: <Package className="w-5 h-5 text-blue-500" />,
		path: "/organisation/artikel",
		category: "Stammdaten",
	},
	{
		title: "Preislisten",
		description: "Verwalte deine Preislisten.",
		icon: <Coins className="w-5 h-5 text-blue-500" />,
		path: "/organisation/administration/preislisten",
		category: "Stammdaten",
	},
];

const aussenauftritt: Card[] = [
	{
		title: "Auftragsformulare",
		description:
			"Auftragsformulare sind individuell konfigurierbare Formulare, mit denen Ihre Kunden digital Aufträge erstellen können.",
		icon: <ClipboardList className="w-5 h-5 text-blue-500" />,
		path: "/organisation/auftragsformulare",
		category: "Aussenauftritt",
	},
	{
		title: "PDF-Gestaltung",
		description:
			"Individualisieren Sie alle PDF-Dokumente Ihres Labors. Kostenvoranschläge, Lieferscheine, Rechnungen, etc.",
		icon: <FileEdit className="w-5 h-5 text-blue-500" />,
		path: "/organisation/pdf-gestaltung",
		category: "Aussenauftritt",
	},
];

const sonstiges: Card[] = [
	{
		title: "Inaktive Kunden",
		description: "Hier landen alle Kunden, die nicht mehr aktiv sind.",
		icon: <UserX className="w-5 h-5 text-blue-500" />,
		path: "/organisation/administration/inaktive-kunden",
		category: "Sonstiges",
	},
];

const Section: React.FC<{ sectionTitle: string; cards: Card[] }> = ({
	sectionTitle,
	cards,
}) => {
	return (
		<div key={sectionTitle} className="mb-6">
			<h2 className="text-lg font-medium text-gray-900 mb-4">
				{sectionTitle}
			</h2>
			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
				{cards.map((section, index) => (
					<OrganizationSectionCard
						key={index}
						title={section.title}
						description={section.description}
						icon={section.icon}
						path={section.path}
					/>
				))}
			</div>
		</div>
	);
};

export const OrganizationOverviewPage: React.FC = () => {
	return (
		<div className="flex flex-col p-6">
			<Section sectionTitle="Laborverwaltung" cards={laborverwaltung} />
			<Section
				sectionTitle="Schnelle Prozesse"
				cards={schnelleProzesse}
			/>
			<Section sectionTitle="Stammdaten" cards={stammdaten} />
			<Section sectionTitle="Aussenauftritt" cards={aussenauftritt} />
			<Section sectionTitle="Sonstiges" cards={sonstiges} />
		</div>
	);
};
